import React, { useId, useRef, useState } from 'react';
import classes from './MixerSupport.module.css';

const profile = 'https://ko-fi.com/setupcoding';
const embed = 'https://ko-fi.com/setupcoding/?hidefeed=true&widget=true&embed=true&preview=true';

function CoffeeIcon({ size, strokeWidth }) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} aria-hidden="true" fill="none" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round">
      <path d="M7 2v3m4-3v3m4-3v3M4 8h13v7a4 4 0 0 1-4 4H8a4 4 0 0 1-4-4V8Zm13 1h2a3 3 0 0 1 0 6h-2M3 22h16" />
    </svg>
  );
}

export function MixerSupport({ mixerName }) {
  const panel = useRef(null);
  const id = useId();
  const [open, setOpen] = useState(false);

  // Same tip panel as the blog and LumenCast: the Ko-fi embed loads only once
  // the dialog opens. Modified clicks and browsers without native dialogs keep
  // the plain link to Ko-fi.
  const show = (event) => {
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.defaultPrevented) return;
    const dialog = panel.current;
    if (!dialog || typeof dialog.showModal !== 'function') return;
    if (dialog.open) {
      event.preventDefault();
      return;
    }
    try {
      dialog.showModal();
    } catch (_) {
      return;
    }
    event.preventDefault();
    setOpen(true);
  };

  const closeOnBackdrop = (event) => {
    if (event.target !== event.currentTarget) return;
    const bounds = event.currentTarget.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) {
      event.currentTarget.close();
    }
  };

  return (
    <section className={classes.Panel} aria-label={`Support ${mixerName}`}>
      <div className={classes.Copy}>
        <h2>Hate ads and affiliate links? <span>Me too.</span></h2>
        <p>That’s why my entire site is free of ads and affiliate links.<br />Enjoyed {mixerName}? Buy me a coffee.</p>
      </div>
      <div className={classes.Action}>
        <a
          href={profile}
          target="_blank"
          rel="noopener noreferrer"
          className={classes.Button}
          aria-haspopup="dialog"
          aria-controls={id}
          aria-label="Support on Ko-fi · Open the Ko-fi tip panel"
          onClick={show}
        >
          <CoffeeIcon size={23} strokeWidth={1.8} />
          <span>Support on Ko-fi</span>
          <span aria-hidden="true">↗</span>
        </a>
        <span className={classes.Thanks}>Thanks for your support!</span>
      </div>
      <dialog ref={panel} id={id} className={classes.Dialog} aria-labelledby={`${id}-title`} onClose={() => setOpen(false)} onClick={closeOnBackdrop}>
        <div className={classes.DialogHeader}>
          <div className={classes.DialogHeading}>
            <span className={classes.DialogMark} aria-hidden="true"><CoffeeIcon size={23} strokeWidth={1.7} /></span>
            <h2 id={`${id}-title`}>Support my projects</h2>
          </div>
          <button className={classes.DialogClose} type="button" aria-label="Close tip panel" onClick={() => panel.current.close()}>×</button>
        </div>
        <div className={classes.DialogBody}>{open && <iframe src={embed} height="712" title="setupcoding on Ko-fi" />}</div>
        <p className={classes.DialogFallback}>
          Prefer to visit Ko-fi directly?{' '}
          <a href={profile} target="_blank" rel="noopener noreferrer">Open Ko-fi in a new tab</a>
        </p>
      </dialog>
    </section>
  );
}
